import React, { useState } from 'react';
import Axios from 'axios';
import { useParams } from 'react-router-dom';
import { IconButton, InputAdornment, Container, TextField, Button, Typography, Box } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Alert from '@mui/material/Alert';

function ConfirmPassword() {
  const { encoded_pk, token } = useParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible(!confirmPasswordVisible);
  };

  const handleConfirmPassword = async () => {
    if (password === confirmPassword) {
      try {
        const response = await Axios.patch(`/api/password-reset/${encoded_pk}/${token}/`, {
          password,
          confirm_password: confirmPassword,
        });

        setSuccessMessage(response.data.message);
      } catch (error) {
        setErrorMessage('Error: Unable to confirm password.');
      }
    } else {
      setErrorMessage('Passwords do not match.');
      setPasswordsMatch(false);
    }
  };

  const navigateToLogin = () => {
    navigate('/');
  };

  return (
    <Container maxWidth="sm" >
      <Typography variant="h3" component="h2" gutterBottom fontWeight="bold">
        Reset Password
      </Typography>

      <div className="mb-4">
        <TextField
          size='small'
          type={passwordVisible ? 'text' : 'password'}
          variant="outlined"
          label="New Password"
          fullWidth
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={togglePasswordVisibility} edge="end">
                  {passwordVisible ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </div>

      <div className="mb-4">
        <TextField
          size='small'
          type={confirmPasswordVisible ? 'text' : 'password'}
          variant="outlined"
          label="Confirm Password"
          fullWidth
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={toggleConfirmPasswordVisibility} edge="end">
                  {confirmPasswordVisible ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </div>

      <Button
        variant="contained"
        color='secondary'
        onClick={handleConfirmPassword}
        style={{ marginRight: '10px' }}
      >
        Save
      </Button>

      <Button variant="contained" color='secondary' onClick={navigateToLogin}>
        Back To Login
      </Button>

      <Box className='Message-display'>
        {successMessage && (
          <Alert aria-label="close" severity="success" onClick={() => setSuccessMessage('')}>
            {successMessage}
          </Alert>
        )}

        {errorMessage && (
          <Alert aria-label="close" severity="error" onClick={() => setErrorMessage('')}>
            {errorMessage}
          </Alert>
        )}
      </Box>
    </Container>
  );
}
export default ConfirmPassword;

